<template>
  <div class="carpin">
    <!-- <p class="title">车销进行中...</p> -->
    <el-row>
      <el-col :span="5" class="img">
        <div class="grid-content" style="background-color: #6590ff;" @click="$message.warning('请在手机端操作完成')">
          <img :src="require('@/assets/image/default/carpin/mobile.png')">
          <span>手机报货</span>
        </div>
        <div class="grid-content" style="background-color: #ff67af;" @click="toJump('调拨录单', '/Account/sys/InvMoveVue/indexVue.html', 9, [9, 325])">
          <img :src="require('@/assets/image/default/carpin/computer.png')">
          <span>调拨录单</span>
        </div>
      </el-col>
      <el-col :span="1" class="divider">
        <el-divider></el-divider>
        <el-divider direction="vertical"></el-divider>
        <el-divider></el-divider>
      </el-col>
      <el-col :span="1" class="divider">
        <el-divider></el-divider>
      </el-col>
      <el-col :span="5" class="img">
        <div class="grid-content" style="background-color: #ff9c65;" @click="toJump(flag ? '调拨录单查看' : '调拨查询', '/Account/sys/billSearchVue/indexVue.html?tag=DBD', 9, [9, 325], true)">
          <img :src="require('@/assets/image/default/carpin/allocation.png')">
          <span>{{ flag ? '调拨录单查看' : '调拨查询' }}</span>
        </div>
      </el-col>
      <el-col :span="1" class="divider" style="align-items: center;">
        <span>库管</span>
        <el-divider></el-divider>
        <span>发货</span>
      </el-col>
      <el-col :span="5" class="img">
        <div class="grid-content" style="background-color: #66d6ff;" @click="toJump('拜访明细', '/Account/sys/visitAnalysisVue/index.html', 120)">
          <img :src="require('@/assets/image/default/carpin/visit.png')">
          <span>拜访明细</span>
        </div>
        <div class="grid-content" style="background-color: #ffdd65;" @click="toJump('拜访轨迹', '/Account/sys/saleManTrajectoryVue/index.html', 119)">
          <img :src="require('@/assets/image/default/advance/storepin.png')">
          <span>拜访轨迹</span>
        </div>
      </el-col>
      <el-col :span="1" class="divider">
        <el-divider></el-divider>
      </el-col>
      <el-col :span="5" class="img">
        <div class="grid-content" style="background-color: #7e65ff;" @click="toJump('上交款结账', '/Account/sys/salCheckout/indexForVue.html', 70, [70, 333])">
          <img :src="require('@/assets/image/default/carpin/salesman.png')">
          <span>上交款结账</span>
        </div>
        <div class="grid-content" style="background-color: #ff7567;" @click="toJump('上交款查询', '/Account/sys/salDetail/indexForVue.html', 114, [114, 333])">
          <img :src="require('@/assets/image/default/work/salesenquiries.png')">
          <span>上交款查询</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    isBetaVersionAndbetaRunModelOfA: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      flag: this.isBetaVersionAndbetaRunModelOfA || false
    }
  },
  mounted () {
    this.onresize()
  },
  methods: {
    onresize () {
      $('.grid-content').css({
        'height': parseInt($('.grid-content').css('width')) * 0.7 + 'px',
        'font-size': parseInt($('.grid-content').css('width')) * 0.07 + 'px'
      })
    },
    toJump (text, path, id, idList, isView) {
      idList = idList ? idList : []
      this.$emit('toJumps', { text, path, id, idList, isView })
      // top.addPanelwithTab(text, path)
    }
  }
}
</script>

<style lang="less" scoped>
.carpin {
  height: calc(100% - 15px);
  overflow: auto;
  margin-top: 15px;
  .title {
    text-align: center;
    color: #2c67ff;
    font-size: 1.2vw;
  }
  .el-row {
    display: flex;
    align-items: center;
    .el-col {
      .grid-content {
        box-shadow: 0px 0px 15px 0px 
        rgba(72, 0, 255, 0.2);
        border-radius: 16px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: space-around;
        position: relative;
        max-width: 266px;
        cursor: pointer;
        color: #fff;
        margin: 0 auto;
        &:nth-child(1) {
          margin-bottom: 24px;
        }
        img {
          width: 40%;
        }
      }
    }
    .divider {
      display: flex;
      flex-flow: column;
      align-items: flex-end;
      ::v-deep .el-divider {
        margin: 0;
        height: 4px;
        background-color: #a5beff;
      }
      .el-divider--vertical {
        height: 12vw;
        width: 4px;
      }
    }
  }
}
</style>